// Keep SIFEN incident reporting hidden while retaining its implementation and history.
export const SHOW_SIFEN_INCIDENTS = false;
